import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Games from '../views/Games.vue'
import Transactions from '../views/Transactions.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/games/:provider', name: 'games', component: Games },
    { path: '/transactions', name: 'transactions', component: Transactions }
  ],
});
